import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const OTPVerificationForm = ({ email, notice, onVerified, onResend, onCancel }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { verifyEmail } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await verifyEmail(email, otp);
    setLoading(false);
    if (result.success) {
      onVerified && onVerified();
    } else {
      setError(result.error || 'Invalid code. Please try again.');
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl border border-white/20 p-8">
        <h2 className="text-2xl font-bold text-white mb-4 text-center">Verify Your Email</h2>
        {notice && <div className="mb-3 text-center text-blue-200 text-sm">{notice}</div>}
        <p className="text-gray-300 mb-6 text-center">Enter the 6-digit code sent to <span className="font-semibold">{email}</span></p>
        {error && <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-3 mb-4 text-red-300 text-sm">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            maxLength={6}
            pattern="[0-9]{6}"
            inputMode="numeric"
            autoFocus
            className="w-full px-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center text-2xl tracking-widest"
            placeholder="Enter code"
            value={otp}
            onChange={e => setOtp(e.target.value.replace(/\D/g, ''))}
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading || otp.length !== 6}
            className="w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 disabled:cursor-not-allowed text-white rounded-lg transition-colors font-medium"
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </form>
        <div className="mt-4 flex justify-between text-sm text-gray-400">
          <button onClick={onResend} className="hover:text-blue-300">Resend code</button>
          <button onClick={onCancel} className="hover:text-red-300">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default OTPVerificationForm;
